import React from "react";
import ImageUploading from "react-images-uploading";
import ImageGallery from "./ImageGallery";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AlertMessage from "./AlertMessage";
import { Box } from "@mui/material";

const ImageUpload = ({ listOfImages, addImageToList, maxLimit, deletedImageList=null }) => {
  return (
    <>
      <ImageUploading
        multiple
        value={listOfImages}
        onChange={addImageToList}
        maxNumber={maxLimit}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
          errors,
        }) => (
          // write your building UI
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                margin: '10px 0px 14px 0px'
              }}
            >
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                onClick={onImageUpload}
                color="secondary"
                sx={{ width: "200px" }}
              >
                Upload image
              </Button>

              {listOfImages.length >= 2 && <Button
                variant="contained"
                color="secondary"
                onClick={onImageRemoveAll}
                sx={{ width: "200px" }}
              >
                Remove all images
              </Button>}

              {errors && errors.maxNumber && (
                <AlertMessage
                  alertMessage={`Number of selected images exceed ${maxLimit}`}
                  alertType="warning"
                />
              )}

              <ImageGallery
                images={imageList}
                updateImage={onImageUpdate}
                removeImage={onImageRemove}
                deletedImageList={deletedImageList}
              />
            </Box>
          </>
        )}
      </ImageUploading>
    </>
  );
};
export default ImageUpload;
